import React from 'react';
import './chatCards.css';

interface ChatAttachmentProps {
  children: React.ReactNode;
}

const ChatAttachment: React.FC<ChatAttachmentProps> = ({ children }) => (
  <div className="v2-chat-attachment">
    <span className="v2-chat-attachment__spacer" aria-hidden />
    <div className="v2-chat-attachment__content">{children}</div>
  </div>
);

export default ChatAttachment;
